import type { RootState } from "@/src/common/redux/store";

export const getCreateCommunityDraft = (state: RootState) => state.onboarding.createCommunityDraft;
